<template>
    <div class="basic-product">
      <div v-if="!is_ecommerce_product">
        <div class="alert alert-info">Product is not mapped with any shopify product.</div>
      </div>
      <div v-if="is_not_variant_product">
        <div class="alert alert-info">Product is not shopify multi-variant product.</div>
      </div>
      <div v-else>
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div></div>
          <div class="d-flex gap-2">
            <b-button @click="resetMapping" variant="primary">Reset Mapping</b-button>
            <b-button @click="saveMapping" variant="primary">Save Mapping</b-button>
           </div>
        </div>

          <div v-for="(item, idx) in roster" class="row" :key="idx" style="border-bottom: 1px solid lightgrey; padding:5px">
            <div class="col-md-6 d-flex justify-content-center align-items-center" style="padding:10px">{{item.name}}</div>
            <div class="col-md-6">
              <div v-if="size_variants_mapping && size_variants_mapping[item.name]">
                <span><b>Name : </b> {{size_variants_mapping[item.name].name}} </span>
                <span> <b> Price : </b> {{size_variants_mapping[item.name].price}}</span>
                <span class="delete-image" @click="removeVariantMapping(item.name)"> <BIconXCircle/></span>
              </div>
              <v-select v-else
                  :options="available_variant_options"
                  name="shopify variants"
                  placeholder="Select shopify variant"
                  @input="selectedOption => setSelectedVariant(selectedOption, item.name)"
              />
            </div>
          </div>
      </div>
    </div>
</template>
<script>

import {http} from "@/config/httpCommon";
import Vue from 'vue'

export default {
  props: ['product_fields'],
     created() {
       let product = this.product_fields;
       if(product) {
         this.is_ecommerce_product = product.is_ecommerce_product;
         if(this.is_ecommerce_product) {
           let ecommerce_product = product.ecommerceproduct[0];
           this.size_variants_mapping = (ecommerce_product.size_variants) ? ecommerce_product.size_variants : {};
           this.$store.commit('set', ['showLoader', true]);
           http.get(`ecommerce/product-variants/${ecommerce_product.ecommerce_product_id}`).then((response) => {
             this.$store.commit('set', ['showLoader', false]);
             this.variant_options = response.data.variants;
             this.is_not_variant_product =
                 Object.keys(this.variant_options).length === 1 &&
                 Object.values(this.variant_options)[0].title === "Default Title";
             if (!this.is_not_variant_product) {
               this.makeAvailableOptions();
             }
           })
           .catch((e) => {
             this.$store.commit('set', ['showLoader', false]);
           });

           if(product.sizes && product.sizes.length > 0) {
             this.roster = product.sizes[0].json_data;
           }
         }

       }
    },
    data() {
        return {
          is_ecommerce_product: false,
          is_not_variant_product: false,
          roster: null,
          size_variants_mapping: {},
          variant_options: [],
          available_variant_options:[]
        }
    },

    methods: {

      setSelectedVariant(option, size) {
         Vue.set(this.size_variants_mapping, size, {
               'id' : option.value,
               'name' : option.label,
               'price' : option.price,

             }
         )
       this.makeAvailableOptions();
      },
      makeAvailableOptions() {
          this.available_variant_options = [];
          let selected_ids = [];
          if(this.size_variants_mapping) {
            selected_ids = Object.values(this.size_variants_mapping).map(variant => variant.id);
          }
          Object.entries(this.variant_options).forEach(([index, obj]) => {
            if(!selected_ids.includes(index)) {
              this.available_variant_options.push({
                value: index,
                label: obj.title,
                price: obj.price
              });
            }
          });
      },
      removeVariantMapping(size) {
        if (this.size_variants_mapping[size]) {
          const variant = this.size_variants_mapping[size];

          this.available_variant_options.push({
            value: variant.id,
            label: this.variant_options[variant.id].title,
            price: this.variant_options[variant.id].price
          });

          Vue.delete(this.size_variants_mapping, size);

        }
      },
      saveMapping() {
        console.log(this.size_variants_mapping)
        this.$store.commit('set', ['showLoader', true]);
        http.post(`save-size-variants-mapping`, {
          product_id : this.product_fields.id,
          size_variants_mapping : this.size_variants_mapping
        }).then((response) => {
          this.showToast('Mapping saved successfully.', 'SUCCESS')
          this.$store.commit('set', ['showLoader', false]);

        })
        .catch((e) => {
          this.$store.commit('set', ['showLoader', false]);
          this.showToast('Error in saving mapping', 'Error')
        });

      },
      resetMapping() {
        this.size_variants_mapping = {};
        this.makeAvailableOptions();
      }


    }
}
</script>

<style lang="scss" scoped>
.delete-image {
  margin-left: 10px;
  cursor: pointer;
  border-radius: 10px;
  height: 18px;
  width: 18px;
  align-items: center;
  justify-content: center;
  background: white;
  color: darkred;

&+div img{
   object-fit: contain;
   border: 1px solid #ccc;
   background: #ddd;
 }
}
</style>
